(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9441],{

/***/ 42604:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

/**
 * @description A module for parsing ISO8601 durations
 */
__webpack_unused_export__ = ({ value: true });
exports.my = exports.ut = exports.Qc = exports.uj = void 0;
/**
 * The pattern used for parsing ISO8601 duration (PnYnMnWnDTnHnMnS).
 */
// PnYnMnWnDTnHnMnS
var numbers = "\\d+";
var fractionalNumbers = "".concat(numbers, "(?:[\\.,]").concat(numbers, ")?");
var datePattern = "(".concat(numbers, "Y)?(").concat(numbers, "M)?(").concat(numbers, "W)?(").concat(numbers, "D)?");
var timePattern = "T(".concat(fractionalNumbers, "H)?(").concat(fractionalNumbers, "M)?(").concat(fractionalNumbers, "S)?");
var iso8601 = "P(?:".concat(datePattern, "(?:").concat(timePattern, ")?)");
var objMap = [
    "years",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds",
];
var defaultDuration = Object.freeze({
    years: 0,
    months: 0,
    weeks: 0,
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
});
/**
 * The ISO8601 regex for matching / testing durations
 */
exports.uj = new RegExp(iso8601);
/** Parse PnYnMnDTnHnMnS format to object */
var parse = function (durationString) {
    var matches = durationString.replace(/,/g, ".").match(exports.uj);
    if (!matches) {
        throw new RangeError("invalid duration: ".concat(durationString));
    }
    // Slice away first entry in match-array (the input string)
    var slicedMatches = matches.slice(1);
    if (slicedMatches.filter(function (v) { return v != null; }).length === 0) {
        throw new RangeError("invalid duration: ".concat(durationString));
    }
    // Check only one fraction is used
    if (slicedMatches.filter(function (v) { return /\./.test(v || ""); }).length > 1) {
        throw new RangeError("only the smallest unit can be fractional");
    }
    return slicedMatches.reduce(function (prev, next, idx) {
        prev[objMap[idx]] = parseFloat(next || "0") || 0;
        return prev;
    }, {});
};
exports.Qc = parse;
/** Convert ISO8601 duration object to an end Date. */
var end = function (durationInput, startDate) {
    if (startDate === void 0) { startDate = new Date(); }
    var duration = Object.assign({}, defaultDuration, durationInput);
    // Create two equal timestamps, add duration to 'then' and return time difference
    var timestamp = startDate.getTime();
    var then = new Date(timestamp);
    then.setFullYear(then.getFullYear() + duration.years);
    then.setMonth(then.getMonth() + duration.months);
    then.setDate(then.getDate() + duration.days);
    // set time as milliseconds to get fractions working for minutes/hours
    var hoursInMs = duration.hours * 3600 * 1000;
    var minutesInMs = duration.minutes * 60 * 1000;
    then.setMilliseconds(then.getMilliseconds() + duration.seconds * 1000 + hoursInMs + minutesInMs);
    // Special case weeks
    then.setDate(then.getDate() + duration.weeks * 7);
    return then;
};
exports.ut = end;
/** Convert ISO8601 duration object to seconds */
var toSeconds = function (durationInput, startDate) {
    if (startDate === void 0) { startDate = new Date(); }
    var duration = Object.assign({}, defaultDuration, durationInput);
    var timestamp = startDate.getTime();
    var now = new Date(timestamp);
    var then = (0, exports.ut)(duration, now);
    var seconds = (then.getTime() - now.getTime()) / 1000;
    return seconds;
};
exports.my = toSeconds;
__webpack_unused_export__ = {
    end: exports.ut,
    toSeconds: exports.my,
    pattern: exports.uj,
    parse: exports.Qc,
};


/***/ }),

/***/ 50308:
/***/ (function(module) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ 89080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ MetaDescription; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);



function MetaDescription(props) {
    var description = props.children;
    return description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }, "description"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "og:description",
                content: description
            }, "og:description"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:description",
                content: description
            }, "twitter:description")
        ]
    }) : null;
}


/***/ }),

/***/ 61012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ speakersGqlFragment; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var src_utils_gql_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72493);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment speakers on people {\n    id\n    avatar {\n      id\n    }\n    name\n    translations {\n      degree\n      title\n      languages_code {\n        code\n      }\n    }\n    country {\n      translations {\n        languages_code {\n          code\n        }\n        name\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var speakersGqlFragment = (0,src_utils_gql_query__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());


/***/ }),

/***/ 96066:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ VideoPageTemplate; },
/* harmony export */   "d": function() { return /* binding */ VideoPageLoader; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_components_player__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44732);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87379);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(81041);
/* harmony import */ var src_utils_motion_transitions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84176);
/* harmony import */ var src_styles_designs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73098);
/* harmony import */ var src_styles_common__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12258);
/* harmony import */ var src_modules_materials_components_MaterialPage__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(33960);
/* harmony import */ var src_components_common_ConstraintContainer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71008);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0px calc(-1 * var(--constraint-container-right-inner-margin)) 0px\n    calc(-1 * var(--constraint-container-left-inner-margin));\n\n  margin-bottom: 10px;\n  ",
        " {\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  ",
        ";\n  & > * {\n    position: absolute !important;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  header {\n    width: auto;\n    height: auto;\n    margin: 0px calc(-1 * var(--constraint-container-right-inner-margin)) 0px\n      calc(-1 * var(--constraint-container-left-inner-margin));\n\n    ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










var VideoPlayerArea = (0,framer_motion__WEBPACK_IMPORTED_MODULE_9__/* .motion */ .E)(styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].div.withConfig({
    displayName: "VideoPage__VideoPlayerArea",
    componentId: "sc-af574446-0"
})(_templateObject(), src_styles_designs__WEBPACK_IMPORTED_MODULE_5__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop));
var VideoPlayerAreaInner = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].div.withConfig({
    displayName: "VideoPage__VideoPlayerAreaInner",
    componentId: "sc-af574446-1"
})(_templateObject1(), (0,src_styles_common__WEBPACK_IMPORTED_MODULE_6__.ar)(16 / 9, "max(20vw, calc(100vh - var(--header-static-height) - 130px))"));
var wistiaOptions = {
    playSuspendedOffScreen: false
};
var VideoPageTemplate = function(param) {
    var tabs = param.tabs, video = param.video, playerProps = param.playerProps, children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), sourceRef = ref[0], setSourceRef = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(src_modules_materials_components_MaterialPage__WEBPACK_IMPORTED_MODULE_7__/* .MaterialPageTemplate */ .r, {
        sourceElement: sourceRef,
        tabs: tabs,
        item: video,
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_common_ConstraintContainer__WEBPACK_IMPORTED_MODULE_8__/* .ConstraintContainer */ .a, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(VideoPlayerArea, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
                    ref: setSourceRef
                }, (0,src_utils_motion_transitions__WEBPACK_IMPORTED_MODULE_4__/* .makeTransition */ .Vr)({
                    fade: true,
                    from: "rightMore",
                    to: "leftMore"
                })), {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(VideoPlayerAreaInner, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_player__WEBPACK_IMPORTED_MODULE_3__/* .NeauviaPlayerLayer */ .jT, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
                            autoPlay: true,
                            video: video,
                            wistiaOptions: wistiaOptions
                        }, playerProps))
                    })
                }), video.id)
            })
        ]
    });
};
var VideoPageLoader = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__["default"])(src_modules_materials_components_MaterialPage__WEBPACK_IMPORTED_MODULE_7__/* .MaterialPageLoader */ .p).withConfig({
    displayName: "VideoPage__VideoPageLoader",
    componentId: "sc-af574446-2"
})(_templateObject2(), (0,src_styles_common__WEBPACK_IMPORTED_MODULE_6__.ar)(16 / 9, "max(20vw, calc(100vh - var(--header-static-height) - 130px))"));


/***/ }),

/***/ 68591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ videoDetailsGqlQuery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var src_modules_materials_graphql_speakers_fragment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61012);
/* harmony import */ var src_modules_materials_graphql_tags_fragment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70763);
/* harmony import */ var src_modules_products_graphql_products_fragment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39738);
/* harmony import */ var src_modules_videos_graphql_videos_shortcodes_fragment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67561);
/* harmony import */ var src_utils_gql_query__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72493);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  query VideoDetailsQuery(\n    $filters: videos_filter\n    $sort: [String]\n    $limit: Int\n  ) {\n    videos(filter: $filters, sort: $sort, limit: $limit) {\n      id\n      slug\n      date_created\n\n      bodyParts {\n        bodyParts_id {\n          slug\n        }\n      }\n      subjects {\n        subjects_id {\n          slug\n        }\n      }\n      translations {\n        languages_code {\n          code\n        }\n        name\n        description\n        excerpt\n      }\n      audioLanguages {\n        languages_code {\n          code\n          name\n        }\n      }\n      thumbnail {\n        id\n      }\n      products {\n        products_id {\n          ...products\n        }\n      }\n      disclaimer\n      source {\n        id\n        url\n        format\n        duration\n        startDate\n        endDate\n      }\n      tags {\n        tags_id {\n          ...tags\n        }\n      }\n      shortcodes {\n        ...shortcodes\n      }\n      speakers {\n        people_id {\n          ...speakers\n        }\n      }\n      attachments {\n        attachments_id {\n          id\n          type\n          translations {\n            name\n            url\n            description\n            file {\n              id\n            }\n            languages_code {\n              code\n            }\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var videoDetailsGqlQuery = (0,src_utils_gql_query__WEBPACK_IMPORTED_MODULE_5__/* .gql */ .Ps)(_templateObject(), src_modules_products_graphql_products_fragment__WEBPACK_IMPORTED_MODULE_3__/* .productsGqlFragment */ .f, src_modules_videos_graphql_videos_shortcodes_fragment__WEBPACK_IMPORTED_MODULE_4__/* .shortcodesGqlFragment */ .U, src_modules_materials_graphql_speakers_fragment__WEBPACK_IMPORTED_MODULE_1__/* .speakersGqlFragment */ .v, src_modules_materials_graphql_tags_fragment__WEBPACK_IMPORTED_MODULE_2__/* .tagsGqlFragment */ .i);


/***/ }),

/***/ 12356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ videoQueryByIdFactory; },
/* harmony export */   "fP": function() { return /* binding */ videoQueryByIdOrSlugFactory; }
/* harmony export */ });
/* unused harmony exports videoQueryFactory, videoQueryBySlugFactory */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36305);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20414);
/* harmony import */ var src_models_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19162);
/* harmony import */ var src_utils_queryCommonOptions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57750);
/* harmony import */ var src_modules_videos_graphql_videos_details_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68591);








var videoQueryFactory = function(apis, filters) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, src_utils_queryCommonOptions__WEBPACK_IMPORTED_MODULE_1__/* .queryCommonOptions.longStale */ .e.longStale), {
        queryKey: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(src_models_query__WEBPACK_IMPORTED_MODULE_0__/* .QueryKey.Video */ .S.Video).concat([
            filters
        ]),
        queryFn: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
            var directus;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            apis.directus()
                        ];
                    case 1:
                        directus = _state.sent();
                        return [
                            2,
                            directus.query(src_modules_videos_graphql_videos_details_query__WEBPACK_IMPORTED_MODULE_2__/* .videoDetailsGqlQuery */ .W, {
                                filters: filters
                            }).then(function(a) {
                                return a.videos[0];
                            })
                        ];
                }
            });
        })
    });
};
var videoQueryByIdFactory = function(apis, videoId) {
    return videoQueryFactory(apis, {
        id: {
            _eq: videoId
        }
    });
};
var videoQueryBySlugFactory = function(apis, slug) {
    return videoQueryFactory(apis, {
        slug: {
            _eq: slug
        }
    });
};
var UUIDRegExp = /^[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}$/;
var videoQueryByIdOrSlugFactory = function(apis, videoIdOrSlug) {
    return UUIDRegExp.test(videoIdOrSlug) ? videoQueryByIdFactory(apis, videoIdOrSlug) : videoQueryBySlugFactory(apis, videoIdOrSlug);
};


/***/ }),

/***/ 21154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _subjectOrSlug_; },
  "getSitemap": function() { return /* binding */ getSitemap; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/services/route.ts + 1 modules
var route = __webpack_require__(38325);
// EXTERNAL MODULE: ./src/modules/videos/components/VideoPage/index.tsx
var VideoPage = __webpack_require__(96066);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./src/components/seo/MetaTitle.tsx
var MetaTitle = __webpack_require__(71508);
// EXTERNAL MODULE: ./vendor/utils/publicUrl.ts
var publicUrl = __webpack_require__(33403);
// EXTERNAL MODULE: ./src/components/seo/LDJSON.tsx
var LDJSON = __webpack_require__(7040);
// EXTERNAL MODULE: ./src/components/seo/MetaCanonical.tsx
var MetaCanonical = __webpack_require__(29557);
// EXTERNAL MODULE: ./src/components/seo/MetaImage.tsx
var MetaImage = __webpack_require__(63884);
// EXTERNAL MODULE: ./src/components/seo/MetaDescription.tsx
var MetaDescription = __webpack_require__(89080);
// EXTERNAL MODULE: ./src/hooks/directus/useTranslateItem.ts
var useTranslateItem = __webpack_require__(70057);
// EXTERNAL MODULE: ./node_modules/react-t7e/lib/index.js
var lib = __webpack_require__(17739);
// EXTERNAL MODULE: ./src/services/directus/common.ts
var common = __webpack_require__(6050);
;// CONCATENATED MODULE: ./src/modules/videos/components/VideoPage/VideoPageSEO.tsx













var VideoPageSEO = function(param) {
    var untranslatedVideo = param.video;
    var translateItem = (0,useTranslateItem/* useTranslateItem */.L)();
    var _ = (0,lib.useTranslate)()._;
    var video = translateItem(untranslatedVideo);
    var canonicalUrl = (0,publicUrl/* publicUrl */.$)(route/* route.video */.BC.video(video).page(true));
    var thumbnailUrl = (0,publicUrl/* publicUrl */.$)((0,common/* getDirectusImageAssetUrl */.yF)(video.thumbnail.id, {
        width: 1200,
        height: 630,
        fit: "cover",
        format: "jpg"
    }));
    var meta = (0,react.useMemo)(function() {
        return {
            "@type": "VideoObject",
            name: video.name,
            description: video.description,
            thumbnailUrl: thumbnailUrl,
            uploadDate: video.date_created,
            url: canonicalUrl,
            abstract: video.excerpt || undefined,
            inLanguage: video.audioLanguages ? video.audioLanguages.map(function(t) {
                return t.languages_code;
            }).map(function(lang) {
                return {
                    "@type": "Language",
                    name: lang.name
                };
            }) : [],
            actor: video.speakers ? video.speakers.map(function(t) {
                return t.people_id;
            }).map(translateItem).map(function(speaker) {
                var ref;
                return (0,_object_spread/* default */.Z)({
                    "@type": "Person",
                    jobTitle: [
                        speaker.degree,
                        speaker.title
                    ].filter(function(v) {
                        return !!v;
                    })
                }, ((ref = speaker.avatar) === null || ref === void 0 ? void 0 : ref.id) ? {
                    image: (0,publicUrl/* publicUrl */.$)((0,common/* getDirectusImageAssetUrl */.yF)(speaker.avatar.id))
                } : {});
            }) : []
        };
    }, [
        video,
        canonicalUrl,
        thumbnailUrl,
        translateItem
    ]);
    var _excerpt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTitle/* MetaTitle */.p, {
                children: _("Video - {videoName}", undefined, {
                    videoName: video.name
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaDescription/* MetaDescription */.l, {
                children: _("Watch online medical aesthetic videos. {videoExcerpt}", undefined, {
                    videoExcerpt: (_excerpt = video.excerpt) !== null && _excerpt !== void 0 ? _excerpt : ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaImage/* MetaImage */.w, {
                src: thumbnailUrl
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaCanonical/* MetaCanonical */.R, {
                href: canonicalUrl
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LDJSON/* LDJSON */.w, {
                data: meta
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/utils/gql/query.ts
var query = __webpack_require__(72493);
;// CONCATENATED MODULE: ./src/modules/videos/graphql/videos-sitemap.query.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  query VideoSitemapQuery {\n    videos(filter: { status: { _eq: "published" } }, limit: -1) {\n      slug\n      date_created\n      date_updated\n      bodyParts {\n        bodyParts_id {\n          slug\n        }\n      }\n      subjects {\n        subjects_id {\n          slug\n        }\n      }\n    }\n  }\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var videoSitemapGqlQuery = (0,query/* gql */.Ps)(_templateObject());

// EXTERNAL MODULE: ./src/models/query.ts
var models_query = __webpack_require__(19162);
;// CONCATENATED MODULE: ./src/modules/videos/hooks/useVideosSitemapQuery.ts




var fetchSitemapVideos = function() {
    return (0,common/* fetchPublicDirectusGqlItems */.S2)(videoSitemapGqlQuery).then(function(a) {
        return a.videos.filter(function(v) {
            return v;
        });
    });
};
var useVideosSitemapQuery = function() {
    return useQuery(QueryKey.VideoSitemap, fetchSitemapVideos);
};

// EXTERNAL MODULE: ./src/modules/materials/utils/tabsFactory.ts + 17 modules
var tabsFactory = __webpack_require__(8469);
// EXTERNAL MODULE: ./src/modules/materials/components/MaterialPage/MaterialPageTabs/types.ts
var types = __webpack_require__(78939);
// EXTERNAL MODULE: ./src/hooks/useAPIs.ts
var useAPIs = __webpack_require__(53100);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/modules/videos/utils/isVideoTaxonomyInvalid.ts
var isVideoTaxonomyInvalid = function(video, params) {
    var subject = (params === null || params === void 0 ? void 0 : params.subjectOrSlug) === video.slug ? null : params === null || params === void 0 ? void 0 : params.subjectOrSlug;
    var bodyPart = (params === null || params === void 0 ? void 0 : params.bodyPartOrSlug) === video.slug ? null : params === null || params === void 0 ? void 0 : params.bodyPartOrSlug;
    var isSubjectInvalid = subject && !video.subjects.find(function(s) {
        return s.subjects_id.slug === subject;
    });
    var isBodyPartInvalid = bodyPart && !video.bodyParts.find(function(s) {
        return s.bodyParts_id.slug === bodyPart;
    });
    var isInvalid = !!(isSubjectInvalid || isBodyPartInvalid);
    if (isInvalid) {
        console.warn("[getServerSideProps] [medical-education] Invalid video taxonomy", video.id, subject, bodyPart);
    }
    return isInvalid;
};

// EXTERNAL MODULE: ./src/modules/videos/utils/videoQueryFactory.ts
var videoQueryFactory = __webpack_require__(12356);
;// CONCATENATED MODULE: ./src/modules/videos/hooks/useVideosDetailsQuery.ts





var useVideosDetailsQuery = function() {
    var apis = (0,useAPIs/* useAPIs */.V)();
    var router = (0,next_router.useRouter)();
    var videoIdOrSlug = String(router.query.slug || router.query.bodyPartOrSlug || router.query.subjectOrSlug);
    var query = (0,es.useQuery)((0,videoQueryFactory/* videoQueryByIdOrSlugFactory */.fP)(apis, videoIdOrSlug));
    if (!query.isLoading && (!query.data || isVideoTaxonomyInvalid(query.data))) {
        router.replace("/404");
    }
    return query;
};

// EXTERNAL MODULE: ./src/modules/user/hooks/useUserNotesQuery.ts + 1 modules
var useUserNotesQuery = __webpack_require__(82191);
// EXTERNAL MODULE: ./src/modules/user/hooks/useUserPermissions.ts
var useUserPermissions = __webpack_require__(65533);
;// CONCATENATED MODULE: ./src/pages/medical-education/videos/[subjectOrSlug]/index.tsx















var playerProps = {
    controls: {
        title: {
            enabled: true,
            backHref: true
        }
    }
};
var _subjectOrSlug_VideoPage = function() {
    var ref = useVideosDetailsQuery(), video = ref.data, isLoading = ref.isLoading;
    var ref1 = (0,useUserNotesQuery/* useUserNotesQuery */.I)(video), notes = ref1.data;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useUserPermissions/* useUserPermissions */.Q)(), 1), userPermissions = ref2[0];
    var videoTabs = (0,react.useMemo)(function() {
        return (0,tabsFactory/* tabsFactory */.M)(video)([
            types/* MaterialPageTabId.Details */.z.Details,
            types/* MaterialPageTabId.Products */.z.Products,
            types/* MaterialPageTabId.Notes */.z.Notes, 
        ].concat((0,_to_consumable_array/* default */.Z)(userPermissions.kol ? [
            {
                id: types/* MaterialPageTabId.UserNotes */.z.UserNotes,
                count: notes === null || notes === void 0 ? void 0 : notes.length
            }
        ] : [])));
    }, [
        video,
        userPermissions.kol,
        notes === null || notes === void 0 ? void 0 : notes.length
    ]);
    if (video && !isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPage/* VideoPageTemplate */.R, {
            tabs: videoTabs,
            video: video,
            playerProps: playerProps,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPageSEO, {
                video: video
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPage/* VideoPageLoader */.d, {});
};
var __N_SSP = true;
function getSitemap() {
    return _getSitemap.apply(this, arguments);
}
function _getSitemap() {
    _getSitemap = (0,_async_to_generator/* default */.Z)(function() {
        var videos, _date_updated;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchSitemapVideos()
                    ];
                case 1:
                    videos = _state.sent();
                    return [
                        2,
                        videos.map(function(video) {
                            return {
                                loc: route/* route.video */.BC.video(video).page(true),
                                lastmod: (_date_updated = video.date_updated) !== null && _date_updated !== void 0 ? _date_updated : video.date_created,
                                priority: 0.6
                            };
                        })
                    ];
            }
        });
    });
    return _getSitemap.apply(this, arguments);
}
/* harmony default export */ var _subjectOrSlug_ = (_subjectOrSlug_VideoPage);


/***/ }),

/***/ 35800:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports, __webpack_require__(67294)) :
  0;
})(this, (function (exports, React) { 'use strict';

  function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
      Object.keys(e).forEach(function (k) {
        if (k !== 'default') {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function () { return e[k]; }
          });
        }
      });
    }
    n["default"] = e;
    return Object.freeze(n);
  }

  var React__namespace = /*#__PURE__*/_interopNamespace(React);

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
  }

  var changedArray = function changedArray(a, b) {
    if (a === void 0) {
      a = [];
    }

    if (b === void 0) {
      b = [];
    }

    return a.length !== b.length || a.some(function (item, index) {
      return !Object.is(item, b[index]);
    });
  };

  var initialState = {
    error: null
  };

  var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
    _inheritsLoose(ErrorBoundary, _React$Component);

    function ErrorBoundary() {
      var _this;

      for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
        _args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
      _this.state = initialState;

      _this.resetErrorBoundary = function () {
        var _this$props;

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        _this.props.onReset == null ? void 0 : (_this$props = _this.props).onReset.apply(_this$props, args);

        _this.reset();
      };

      return _this;
    }

    ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
      return {
        error: error
      };
    };

    var _proto = ErrorBoundary.prototype;

    _proto.reset = function reset() {
      this.setState(initialState);
    };

    _proto.componentDidCatch = function componentDidCatch(error, info) {
      var _this$props$onError, _this$props2;

      (_this$props$onError = (_this$props2 = this.props).onError) == null ? void 0 : _this$props$onError.call(_this$props2, error, info);
    };

    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
      var error = this.state.error;
      var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
      // happens to *also* be in the resetKeys array, we'd end up resetting
      // the error boundary immediately. This would likely trigger a second
      // error to be thrown.
      // So we make sure that we don't check the resetKeys on the first call
      // of cDU after the error is set

      if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
        var _this$props$onResetKe, _this$props3;

        (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null ? void 0 : _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
        this.reset();
      }
    };

    _proto.render = function render() {
      var error = this.state.error;
      var _this$props4 = this.props,
          fallbackRender = _this$props4.fallbackRender,
          FallbackComponent = _this$props4.FallbackComponent,
          fallback = _this$props4.fallback;

      if (error !== null) {
        var _props = {
          error: error,
          resetErrorBoundary: this.resetErrorBoundary
        };

        if ( /*#__PURE__*/React__namespace.isValidElement(fallback)) {
          return fallback;
        } else if (typeof fallbackRender === 'function') {
          return fallbackRender(_props);
        } else if (FallbackComponent) {
          return /*#__PURE__*/React__namespace.createElement(FallbackComponent, _props);
        } else {
          throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
        }
      }

      return this.props.children;
    };

    return ErrorBoundary;
  }(React__namespace.Component);

  function withErrorBoundary(Component, errorBoundaryProps) {
    var Wrapped = function Wrapped(props) {
      return /*#__PURE__*/React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/React__namespace.createElement(Component, props));
    }; // Format for display in DevTools


    var name = Component.displayName || Component.name || 'Unknown';
    Wrapped.displayName = "withErrorBoundary(" + name + ")";
    return Wrapped;
  }

  function useErrorHandler(givenError) {
    var _React$useState = React__namespace.useState(null),
        error = _React$useState[0],
        setError = _React$useState[1];

    if (givenError != null) throw givenError;
    if (error != null) throw error;
    return setError;
  }
  /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */

  exports.ErrorBoundary = ErrorBoundary;
  exports.useErrorHandler = useErrorHandler;
  exports.withErrorBoundary = withErrorBoundary;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=react-error-boundary.umd.js.map


/***/ })

}]);